import { render, staticRenderFns } from "./ProjectTemplate_bak.vue?vue&type=template&id=0ea093dd&scoped=true"
import script from "./ProjectTemplate_bak.vue?vue&type=script&lang=js"
export * from "./ProjectTemplate_bak.vue?vue&type=script&lang=js"
import style0 from "./ProjectTemplate_bak.vue?vue&type=style&index=0&id=0ea093dd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea093dd",
  null
  
)

export default component.exports